var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['sign-up'],attrs:{"id":"embed-sign-up"}},[_c('div',{staticClass:"sign-up__container"},[_c('hot-iframe-sso',{attrs:{"hasLogo":_vm.hasLogo}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }